import https from "@/lib/https";
import type {
  TeamDetail,
  TeamPayload,
  GetTeamListParams,
} from "@/interface/masterManagement";
import type { ApiResponse, PaginationResponse } from "@/interface/common";

const BASE_URL = "/api/master/teams/";

export const getTeamList = async (
  params: GetTeamListParams,
): Promise<ApiResponse<PaginationResponse<TeamDetail>>> => {
  return await https.get<ApiResponse<PaginationResponse<TeamDetail>>>(
    BASE_URL,
    params,
  );
};

export const createTeam = async (
  payload: TeamPayload,
): Promise<ApiResponse<TeamDetail>> => {
  return await https.post<ApiResponse<TeamDetail>>(BASE_URL, payload);
};

export const updateTeam = async (
  id: number | string,
  payload: TeamPayload,
): Promise<ApiResponse<TeamDetail>> => {
  return await https.put<ApiResponse<TeamDetail>>(
    `${BASE_URL}${id}/`,
    payload,
  );
};

export const deleteTeam = async (
  id: number | string,
): Promise<ApiResponse<void>> => {
  return await https.delete<ApiResponse<void>>(`${BASE_URL}${id}/`);
};
